<template>
  <div class="editable"
       contenteditable="true"
       @blur="update">
    {{ content }}
  </div>
</template>

<script>
export default {
	name: 't-editable',
	props: {
		content: {
			validator: prop => typeof prop === 'string' || prop === null,
			required: true
		}
	},
	methods: {
		update (event) {
			this.$emit('update:content', event.target.textContent)
	  }
	}
}
</script>

<style scoped>
    .editable {
        padding: 10px 10px 10px 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/editable/index.vue